import { type AttachedFilesRequest } from "legacyComponents/FileUploadContainer.types";

import { type EditorContent } from "commonComponents/btWrappers/editor/editor.types";

import { type SpecificationResponse } from "handlers/models";

export type SpecificationDetailsFormActions =
    | undefined
    | "save"
    | "share"
    | "publish"
    | "unpublish"
    | "delete"
    | "saveToCatalog";

export type SpecificationDisplayActionType =
    | "publish"
    | "unpublish"
    | "viewingPermissions"
    | "save"
    | undefined;

export enum SpecificationOwnerShareMode {
    NotShared = 0,
    SharedWithAllOwners = 1,
}
export enum SpecificationSubShareMode {
    NotShared = 0,
    SharedWithAllSubs = 1,
}

/**
 * Transform APIx response to match old API v1 pattern where content was already an EditorContent.
 * This prevents flickering by ensuring content is transformed during fetch (not during render).
 */
export type SpecificationWithEditorContent = Omit<
    SpecificationResponse,
    "content" | "publishedContent"
> & {
    content: EditorContent;
    publishedContent: EditorContent | null;
};

export interface ISpecificationFormValues {
    specificationContent: EditorContent;
    ownerShareMode: SpecificationOwnerShareMode;
    subShareMode: SpecificationSubShareMode;
    attachedFiles?: AttachedFilesRequest;
    /**
     * Explicit global user IDs to notify for the client/sub audiences, as selected by the builder
     * in the publish/viewing-permissions modals. Transient - never populated from a fetched spec,
     * only ever set immediately before a publish/share save.
     */
    usersToNotify: number[];
}
